import { useEffect, useState } from 'react'
import Lenis from 'lenis'
import { experienceState } from '../experienceState'

export function useExperienceScroll(active: boolean) {
  const [chapter, setChapter] = useState(0)

  useEffect(() => {
    experienceState.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches
    if (!active) return

    const lenis = new Lenis({
      lerp: experienceState.reducedMotion ? 1 : 0.075,
      wheelMultiplier: 0.86,
      touchMultiplier: 1.1,
      anchors: true,
    })
    let rafId = 0
    let lastScroll = window.scrollY

    lenis.on('scroll', ({ scroll, limit, velocity }: { scroll: number; limit: number; velocity: number }) => {
      const progress = limit > 0 ? Math.min(1, Math.max(0, scroll / limit)) : 0
      experienceState.progress = progress
      experienceState.velocity = velocity
      document.documentElement.style.setProperty('--page-progress', progress.toString())

      const sections = [0.12, 0.31, 0.51, 0.71, 0.89]
      setChapter(sections.filter((stop) => progress >= stop).length)
      lastScroll = scroll
    })

    const raf = (time: number) => {
      lenis.raf(time)
      if (Math.abs(window.scrollY - lastScroll) > 2) lastScroll = window.scrollY
      rafId = requestAnimationFrame(raf)
    }
    rafId = requestAnimationFrame(raf)

    return () => {
      cancelAnimationFrame(rafId)
      lenis.destroy()
    }
  }, [active])

  return chapter
}
